import SvgIcon from "@mui/material/SvgIcon";
import type { SvgIconProps } from "@mui/material/SvgIcon";

/**
 * Official HubSpot sprocket mark in HubSpot orange (#ff7a59).
 *
 * Wrapped in MUI's SvgIcon so it accepts the same props (e.g. fontSize="small")
 * as the lucide-mui icons and drops into an IconButton the same way. Uses an
 * explicit htmlColor so it keeps the brand colour rather than inheriting the
 * theme text colour.
 */
export default function HubSpotLogo(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" htmlColor="#ff7a59" aria-label="HubSpot" {...props}>
      <path d="M18.164 7.93V5.084a2.198 2.198 0 0 0 1.267-1.978v-.067A2.2 2.2 0 0 0 17.238.845h-.067a2.2 2.2 0 0 0-2.193 2.194v.067a2.196 2.196 0 0 0 1.252 1.973l.013.006v2.852a6.22 6.22 0 0 0-2.969 1.31l.012-.01-7.854-6.106A2.475 2.475 0 0 0 5.5 2.64a2.483 2.483 0 1 0-2.484 2.484c.475-.001.917-.135 1.294-.368l-.011.006 7.73 6.011a6.247 6.247 0 0 0-1.05 3.475c0 1.335.42 2.572 1.134 3.587l-.013-.019-2.351 2.351a1.966 1.966 0 0 0-.585-.093 2.032 2.032 0 1 0 2.032 2.031c0-.21-.033-.412-.093-.602l.004.014 2.325-2.325a6.256 6.256 0 1 0 4.629-11.25l-.045-.008zm-1.909 9.4a3.208 3.208 0 1 1 .002-6.416 3.208 3.208 0 0 1-.002 6.416z" />
    </SvgIcon>
  );
}
